import styled, { css } from 'styled-components'

const CustomContainer = styled.div`
    ${({ theme }) => {
        return css`
            display: flex;
            flex-direction: column;
            
        `;
    }}
`;

const BottomNavContainer = styled.div`
    ${({ theme }) => {
        const { device } = theme;
        return css`
            display: flex;
            justify-content: space-between;
            // height: 66px;
            padding: 40px 22px 9px;
            @media ${device.tabletM} {
                justify-content: start;
                align-items: center;
                padding: 40px 0px 0px 100px;
            }
        `;
    }}
`;

const IconContainer = styled.div`
${({ theme }) => {
        const { colors, device } = theme;
        return css`
            display: flex;
            font-family: 'Noto Sans KR', sans-serif;
            font-style: normal;
            font-weight: bold;
            font-size: 14px;
            line-height: 16px;
            display: flex;
            align-items: center;
            color: rgba(174, 191, 195, 1);
            cursor: pointer;
            & img {
                display: none;
            }
            @media ${device.tabletM} {
                font-size: 16px;
                line-height: 18px;
                margin-right: 65px;
                height: 22px;
                align-items: center;
                padding-bottom: 11px;
                display: flex;
                & img {
                    display: flex;
                    fill: blue;
                    stroke: blue;
                }
                & svg {
                    fill: blue;
                    stroke: blue;
                }
                & div {
                    min-width: 67px;
                    padding-bottom: 2px;
                }
            }
            ${(props) => props.selected &&
                css`
            color: ${colors.blue_1};
            // border-bottom: 4px solid #00B9E1; 
            `
            }
    `
    }}
`;

const Icon = styled.img`
${({ theme }) => {
        const { colors, device } = theme;
        return css`
        @media ${device.tabletM} {
            width: 100%;
            height: 100%;
            align-items: center;
            margin-right: 10px;
            path {
                stroke: blue;
            }
        }
        ${(props) => props.selected &&
                css`
        color: ${colors.blue_1};
        `
            }
    `
    }}
`;

const BottomInfoContainer = styled.div`
    ${({ theme }) => {
        const { device } = theme;
        return css`
        background: #FBFBFB;
        // width: 100vw;
        // height: 1135px;
        padding: 30px 20px;
        @media ${device.tabletM} {
            padding: 30px 60px 30px 100px;
            min-height: 32vh;
            display: flex;
            flex-direction: row;
        }
        `;
    }}
`;

const InfoTitle = styled.div`
    ${({ theme }) => {
        const { colors, device } = theme;
        return css`
        font-family: Noto Sans KR;
        font-style: normal;
        font-weight: 500;
        font-size: 14px;
        line-height: 16px;
        color: ${colors.blue_3};
        margin-bottom: 15px;
        @media ${device.tabletM} {
            margin-bottom: 0px;
            font-size: 16px;
            line-height: 18px;
            min-width: 94px;
        }
        `;
    }}
`;

const InfoTitleInvestigation = styled(InfoTitle)`
    ${({ theme }) => {
        const { device } = theme;
        return css`
        margin-bottom: 0px;
        @media ${device.tabletM} {
            margin-bottom: 0px;
        }
        `;
    }}
`;

const SelectRowContainer = styled.div`
    ${({ theme }) => {
        return css`
        display: flex;
        justify-content: flex-start;
        align-items: center;
        // padding-top: 15px;
        `;
    }}
`;

const SelectAreaContainer = styled.div`
    ${({ theme }) => {
        const { fonts, colors } = theme;
        return css`
        box-sizing: border-box;
        // font-size: ${fonts.size.small};
        position: relative;
        width: 237px;
        border-radius: 4px;
        border: 1px solid #EEEEEE;
        background-size: 20px;
        cursor: pointer;
        font-weight: 500;
        font-size: 14px;
        line-height: 16px;
        color: ${colors.blue_3};
        & div {
            border: none;
        }
        `;
    }}
`;

const SelectAreaAbsoluteContainer = styled(SelectAreaContainer)`
    ${({ theme }) => {
        return css`
        position: absolute;
        top: 129px;
        left: 22px;
        z-index: 100;
        width: 200px;
        height: 40px;
        margin-top: 0px;
        border-radius: 10px;
        &:focus {
            outline: none;
        }
        &:active {
            outline: none;
        }
        & div {
            border: none;
        }
        & div:focus {
            outline: none;
        }
        & div:active {
            outline: none;
        }
        `;
    }}
`;

const SelectYearContainer = styled.div`
    ${({ theme }) => {
        const { device, colors } = theme;
        return css`
        box-sizing: border-box;
        position: relative;
        border-radius: 4px;
        background-size: 20px;
        cursor: pointer;
        font-weight: 500;
        font-size: 14px;
        line-height: 16px;
        margin-top: 0px;
        padding-top: 0px;
        color: ${colors.blue_3};
        width: 100%;
        border: 1px solid #EEEEEE;
        & div {
            border: none;
        }
        @media ${device.tabletM} {
            // width: 87px;
            width: 102px;
            height: 42px;
        }
        `;
    }}
`;

const SelectStartYearContainer = styled(SelectYearContainer)`
    ${({ theme }) => {
        const { device } = theme;
        return css`
        width: 38.4vw;
        border: 1px solid #EEEEEE;
        @media ${device.tabletM} {
            // width: 87px;
            width: 102px;
        }
        `;
    }}
`;

const DataVisualizeContainer = styled.div`
    ${({ theme }) => {
        return css`
        width: 100%;
        background: white;
        border: 1px solid #EEEEEE;
        box-sizing: border-box;
        border-radius: 5px;
        padding: 15px 45px;
        margin-bottom: 45px;
        @media (min-width: 806px) {
            margin-bottom: 0px;
        }
        @media (min-width: 1426px) {
            max-height: 203px;
            margin-bottom: 0px;
        }
        `;
    }}
`;

const DataVisualizeContainer02 = styled(DataVisualizeContainer)`
    ${({ theme }) => {
        const { device } = theme;
        return css`
        min-width: 335px;
        display: flex;
        flex-direction: column;
        @media (min-width: 610px) {
            flex-direction: row;
        }
        @media ${device.tabletM} {
            // min-height: 203px;
            // min-width: 570px;
            display: flex;
            flex-direction: row;
        }
        @media (min-width: 976px) {
        padding: 45px 45px 45px 45px;
            flex-direction: column;
            // max-width: 345px;
        }
        @media (min-width: 1426px) {
            justify-content: space-between;
            align-items: center;
            flex-direction: row;
            max-height: auto;
            padding: 45px;
        }
        `;
    }}
`;

const DataVisualizeContainer03 = styled(DataVisualizeContainer)`
    ${({ theme }) => {
        return css`
        overflow-x: scroll;
        overflow-y: hidden;
        padding: 25px;
        @media (min-width: 1426px) {
            max-height: 256px;
            padding: 25px;
        }
        `;
    }}
`;



const DataVisualizeContainer04 = styled(DataVisualizeContainer)`
    ${({ theme }) => {
        return css`
        @media (min-width: 610px) {
            padding: 45px;
            min-height: 168px;
        }
        @media (min-width: 976px) {
            min-height: 339px;
        }
        @media (min-width: 1426px) {
            min-height: 203px;
        }
        `;
    }}
`;

const DataVisualizeContainer05 = styled(DataVisualizeContainer)`
    ${({ theme }) => {
        return css`
        overflow-x: scroll;
        padding: 25px;
        @media (min-width: 806px) {
            min-height: 203px;
            padding: 45px;
        }
        `;
    }}
`;
const DataVisualizeContainer06 = styled.div`
    ${({ theme }) => {
        return css`
        width: 100%;
        background: white;
        border: 1px solid #EEEEEE;
        box-sizing: border-box;
        border-radius: 5px;
        padding: 25px;
        margin-bottom: 45px;
       
        display: flex;
        justify-content: center;

        @media (min-width: 1426px) {
            max-height: 203px;
        }
        `;
    }}
`;

const InvestigationAreaInfoContainer = styled.div`
    ${({ theme }) => {
        return css`
        width: 100%;
        background: white;
        border: 1px solid #EEEEEE;
        box-sizing: border-box;
        border-radius: 5px;
        // padding: 25px;
        margin-bottom: 45px;
       
        display: flex;
        flex-direction: row;
        // justify-content: center;
        max-width: calc(50vw - 100px);
        overflow-x: scroll;

        @media (min-width: 1426px) {
            max-height: 203px;
            // padding: 45px;
        }
        `;
    }}
`;

const SelectYearBetweenWord = styled.div`
    ${({ theme }) => {
        return css`
        // min-width: 26px;
        font-family: Noto Sans KR;
        font-style: normal;
        font-weight: bold;
        font-size: 14px;
        line-height: 16px;
        color: #22455C;
        margin: auto 10px;
        display: flex;
        align-items: center;
        justify-content: center;
        `;
    }}
`;



const DataContainerWrapper = styled.div`
    ${({ theme }) => {
        return css`
        display: flex;
        justify-content:
        margin-bottom: 30px;
        // min-width: 285px;
        // max-width: 335px;
        width: 100%;
        @media (min-width: 610px) {
            margin-bottom: 0px;
            // min-width: 335px;
        }
        @media (min-width: 976px) {
            // margin-bottom: 30px;
            // min-width: 335px;
        }
        `;
    }}
`;

const DataInfoGraphicContainer = styled.div`
    ${({ theme }) => {
        return css`
        display: flex;
        flex-direction: column;
        text-align: start;
        @media (min-width: 610px) {
            // padding-top: 15px;
        }
        `;
    }}
`;

const DataInfoGraphicContainer02 = styled(DataInfoGraphicContainer)`
    ${({ theme }) => {
        return css`
        @media (min-width: 610px) {
            margin-right: 45px;
        }
        @media (min-width: 1510px) {
        padding-top: 0px;
        }
        `;
    }}
`;

const DataInfoTitle = styled.div`
    ${({ theme }) => {
        return css`
        font-family: Noto Sans KR;
        font-style: normal;
        font-weight: 500;
        font-size: 14px;
        line-height: 16px;
        color: #869396;
        margin-bottom: 10px;
        @media (min-width: 806px) {
            // padding-top: 15px;
            font-size: 20px;
            line-height: 20px;
            margin-bottom: 13px;
        }
        `;
    }}
`;

const DataInfoTitle02 = styled(DataInfoTitle)`
    ${({ theme }) => {
        return css`
        font-family: Noto Sans KR;
        font-style: normal;
        font-weight: 500;
        font-size: 14px;
        line-height: 16px;
        color: #869396;
        margin-bottom: 10px;
        @media (min-width: 806px) {
            font-size: 20px;
            line-height: 20px;
            padding-top: 0px;
            margin-bottom: 13px;
        }
        `;
    }}
`;

const DataInfoNumber = styled.div`
    ${({ theme }) => {
        return css`
        font-family: Noto Sans KR;
        font-style: normal;
        font-weight: bold;
        font-size: 33px;
        line-height: 40px;
        color: #00B9E1;
        display: flex;
        align-items: baseline;
        & span {
            font-weight: 400;
            // margin-right: 8px;
            font-size: 25px;
            line-height: 40px;
            align-items: baseline;
        }
        `;
    }}
`;

const DataInfoNumber01 = styled(DataInfoNumber)`
    ${({ theme }) => {
        const { device } = theme;
        return css`
        letter-spacing : 0.05em;
        @media ${device.tabletM} {
            min-width: 107px;
        }
        `;
    }}
`;

const DataInfoNumber02 = styled(DataInfoNumber)`
    ${({ theme }) => {
        const { device } = theme;
        return css`
        letter-spacing : 0.05em;
        word-break: keep-all;
        `;
    }}
`;

const DataInfoNumber03 = styled(DataInfoNumber)`
    ${({ theme }) => {
        const { device } = theme;
        return css`
        letter-spacing : 0.05em;
        word-break: break-all;
        `;
    }}
`;

const DataInfoDescription = styled.div`
    ${({ theme }) => {
        return css`
        font-family: Noto Sans KR;
        font-style: normal;
        font-weight: 400;
        font-size: 16px;
        // letter-spacing : 0.03em;
        line-height: 40px;
        min-width: 160px;
        color: #22455C;
        & span {
            font-weight: 700;
        }
        `;
    }}
`;

const DataInfoSource = styled.div`
    ${({ theme }) => {
        return css`
        font-family: Noto Sans KR;
        font-style: normal;
        font-weight: 400;
        font-size: 14px;
        line-height: 20px;
        color: #000000;
        margin-top: 8px;
        text-align: start;
        @media (min-width: 806px) {
            font-size: 15px;
            line-height: 22px;
            margin-top: 10px;
        }
        `;
    }}
`;

const WebContainer = styled.div`
    ${({ theme }) => {
        const { device } = theme;
        return css`
        @media ${device.tabletM} {
            display: grid;
            grid-template-columns: 107px 1fr;
        }
        `;
    }}
`;

const WebContainerCol01 = styled.div`
    ${({ theme }) => {
        const { device } = theme;
        return css`
        @media ${device.tabletM} {
            grid-row: 1/3;
            grid-column: 1/2;
        }
        `;
    }}
`;

const WebContainerCol02 = styled.div`
    ${({ theme }) => {
        const { device } = theme;
        return css`
        @media ${device.tabletM} {
            grid-row: 1/3;
            grid-column: 2/3;
            width: calc(100vw - 107px);
        }
        `;
    }}
`;

const Column = styled.div`
    ${({ theme }) => {
        const { device } = theme;
        return css`
        @media ${device.tabletM} {
            width: calc(100% - 5px);
        }
        `;
    }}
`;

const ColumnInvestigationInfo = styled.div`
    ${({ theme }) => {
        const { device } = theme;
        return css`
        @media ${device.tabletM} {
            display: flex;
            justify-content: center;
            flex-direction: column;
            width: 270px;
            padding: 45px;
            justify-content: flex-start;
        }
        `;
    }}
`;

const ColumnInvestigationImageContainer = styled.div`
    ${({ theme }) => {
        const { device } = theme;
        return css`
        display: flex;
        flex-direction: row;
        max-width:187px;
        & img {
            border-radius: 10px;
            margin-right: 5px;
        }
        @media ${device.tabletM} {
            padding: 30px 0 20px;
        }
        `;
    }}
`;

const ColumnGap = styled.div`
    ${({ theme }) => {
        const { device } = theme;
        return css`
        display: none;
        @media ${device.tabletM} {
            width: 40px;
            display: block;
        }
        `;
    }}
`;

const ColumnSecondTab = styled(Column)`
    ${({ theme }) => {
        const { device } = theme;
        return css`
        @media ${device.tabletM} {
            width: calc(100% - 10px);
        }
        `;
    }}
`;

const Row = styled.div`
    ${({ theme }) => {
        const { device } = theme;
        return css`
        margin-bottom: 10px;
        @media ${device.tabletM} {
            display: flex;
            flex-direction: row;
            align-items: center;
            justify-content: space-between;
        }
        `;
    }}
`;

const RowFirstTab = styled.div`
    ${({ theme }) => {
        return css`
        display: flex;
        flex-direction: column;
        width: 100%;
        @media (min-width: 976px) {
            display: flex;
            flex-direction: row;
            align-items: baseline;
            justify-content: space-between;
        }
        `;
    }}
`;

const RowThirdTab = styled(Row)`
    ${({ theme }) => {
        const { device } = theme;
        return css`
        @media ${device.tabletM} {
            height: 42px;
        }
        `;
    }}
`;

const FlexRow = styled.div`
    ${({ theme }) => {
        return css`
        display: flex;
        flex-wrap: wrap;
        align-items: baseline;
        `;
    }}
`;

// 현장조사
const ReturnIcon = styled.img`
${({ theme }) => {
        const { device } = theme;
        return css`
        width: 12px;
        height: 9.57px;
        align-items: center;
        margin-right: 5px;
        @media ${device.tabletM} {
            
        }
    `
    }}
`;
const CoreAreaBtnContainer = styled.div`
    ${({ theme }) => {
        const { device } = theme;
        return css`
        border: 1px solid rgba(0, 185, 225, 0.5);
        box-sizing: border-box;
        border-radius: 5px;
        position: relative;
        cursor: pointer;
        font-weight: 500;
        font-size: 14px;
        line-height: 16px;
        margin-top: 0px;
        padding: 8px 7px;
        font-family: Noto Sans KR;
        font-style: normal;
        font-weight: 500;
        font-size: 12px;
        line-height: 16px;
        color: #00B9E1;
        // width: 102px;
        height: 32px;
        display: flex;
        justify-content: center;
        align-items: center;
        @media ${device.tabletM} {
        }
        `;
    }}
`;

const InvestigationTableAreaNameWrapper = styled.div`
    ${({ theme }) => {
        const { device } = theme;
        return css`
        font-family: Noto Sans KR;
        font-style: normal;
        font-weight: bold;
        font-size: 20px;
        line-height: 22px;
        color: #22455C;
        margin-bottom: 26px;
        @media ${device.tabletM} {
            font-size: 22px;
            line-height: 24px;
            margin-bottom: 25px;
        }
        `;
    }}
`;

const RowThirdTabTitle = styled(Row)`
    ${({ theme }) => {
        const { device } = theme;
        return css`
        display: flex;
        flex-direction: row;
        align-items: center;
        justify-content: space-between;
        margin-bottom: 14px;
        @media ${device.tabletM} {
            margin-bottom: 12px;
            height: 32px;
        }
        `;
    }}
`;

const RowTable = styled(Row)`
    ${({ theme }) => {
        const { device } = theme;
        return css`
        display: flex;
        flex-direction: row;
        align-items: center;
        justify-content: flex-start;
        margin-bottom: 14px;
        @media ${device.tabletM} {
            margin-bottom: 12px;
        }
        `;
    }}
`;

//테이블 항목명
const InvestigationTypeWrapper = styled.div`
    ${({ theme }) => {
        const { device } = theme;
        return css`
        font-family: Noto Sans KR;
        font-style: normal;
        font-weight: 500;
        font-size: 14px;
        line-height: 16px;
        color: rgba(134, 147, 150, 0.9);
        margin-right: 37px;
        min-width: 52px;
        @media ${device.tabletM} {
            font-size: 16px;
            line-height: 20px;
            margin-right: 30px;
            min-width: 59px;
        }
        `;
    }}
`;

//테이블 내용
const InvestigationLabNameWrapper = styled.div`
    ${({ theme }) => {
        const { device } = theme;
        return css`
        font-family: Noto Sans KR;
        font-style: normal;
        font-weight: normal;
        font-size: 14px;
        line-height: 16px;
        color: #38586C;
        @media ${device.tabletM} {
            font-size: 16px;
            line-height: 20px;
        }
        `;
    }}
`;

const ArrowDownWrapper = styled.div`
    // width: 10px;
    // height: 40px;
    height: 8px;
    margin-left: 4px;
    margin-right: 8px;
    align-self: center;

    display: flex;
    cursor: pointer;
    position: relative;
    & img {
        color: #00B9E1;
    }
`;

const ArrowDownWrapper02 = styled.div`
    // width: 10px;
    // height: 40px;
    height: 8px;
    margin-left: 4px;
    margin-right: 8px;
    align-self: center;
    display: flex;
    cursor: pointer;
    position: relative;
    & img {
        color: #00B9E1;
    }
`;

const UnitContainer = styled.div`
    ${(props) => {
        return css`
        position: absolute;
        top: 35px;
        left: -61px;
        background-color: white;
        height: 88px;
        background: #FFFFFF;
        border: 1px solid #EEEEEE;
        border-radius: 5px;
        font-weight: 500;
        font-size: 30px;
        line-height: 34px;
        color: #22455C;
        width: 72px;
        text-align: center;
        align-items: center;
        display: flex;
        flex-direction: column;
        justify-content: space-around;
        `
    }}
`;

const UnitOne = styled.div`
    ${(props) => {
        return css`
        color: ${props.selected ? '#00B9E1' : '#22455C'};
            background-color:${props.selected ? '#DFF3F6' : '#fff'};
            width: 100%;
            height: 44px;
            display: flex;
            align-items: center;
            justify-content: center;

        &:hover {
            color: #00B9E1;
            background-color: #DFF3F6;
        }
        `
    }}
`;


const styledComponents = { CustomContainer, BottomNavContainer, IconContainer, Icon, BottomInfoContainer, InfoTitle, SelectRowContainer, SelectAreaContainer, SelectAreaAbsoluteContainer, SelectYearContainer, DataVisualizeContainer, SelectStartYearContainer, SelectYearBetweenWord, DataVisualizeContainer02, DataVisualizeContainer03, DataVisualizeContainer04, DataVisualizeContainer05, DataVisualizeContainer06, DataContainerWrapper, DataInfoGraphicContainer, DataInfoGraphicContainer02, DataInfoTitle, DataInfoTitle02, DataInfoNumber, DataInfoNumber01, DataInfoNumber02, DataInfoNumber03, DataInfoDescription, DataInfoSource, WebContainer, WebContainerCol01, WebContainerCol02, Column, ColumnSecondTab, Row, RowFirstTab, RowThirdTab, RowThirdTabTitle, ColumnGap, InfoTitleInvestigation, ReturnIcon, CoreAreaBtnContainer, InvestigationTableAreaNameWrapper, RowTable, InvestigationLabNameWrapper, InvestigationTypeWrapper, ArrowDownWrapper, ArrowDownWrapper02, UnitContainer, UnitOne, FlexRow, ColumnInvestigationInfo, InvestigationAreaInfoContainer, ColumnInvestigationImageContainer };

export default styledComponents;